import Vue from "vue";
import Vuex from "vuex";

import app from './modules/app';
import auth from './modules/auth';
import user from './modules/user';
import systems from './modules/systems';
import adherents from './modules/adherents';
import user_groups from './modules/user_groups';
import sensors from './modules/sensors';
import plates from './modules/plates';
import rentals from './modules/rentals';
import structure from './modules/structure';
import extractions from './modules/extractions';
import createPersistedState from "vuex-persistedstate";
import system_type from './modules/system_type';
import system_manufacturer from './modules/system_manufacturer';
import system_alarm_periodic from './modules/system_alarm_periodic';
import system_alarm_seuil from './modules/system_alarm_seuil';
import system_alarm_gps from './modules/system_alarm_gps';
import display_unit from './modules/display_unit';


Vue.use(Vuex);

const Statepaths = ["user.structure_id"]


export default new Vuex.Store({
     
    plugins: [
        createPersistedState({
            paths: Statepaths
          }),
    ],
    modules: {
        app,
        auth,
        user,
        systems,
        adherents,
        user_groups,
        system_type,
        system_manufacturer,
        sensors,
        plates,
        rentals,
        extractions,
        structure,
        system_alarm_periodic,
        system_alarm_seuil,
        system_alarm_gps,
        display_unit,
        //type_groups,
    }
});